import React, { memo, useMemo } from 'react';

import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import { cicChangePropTypes } from '../../LoanCicHistory.propTypes';

import { getCicChangesTableConfig } from './CicChangesTable.config';

const CicChangesTable = ({
  changes,
  hasActions = false,
  isEditAllowed = false,
  onEdit = null,
  onOpenHistory = null,
}) => {
  const config = useMemo(
    () => getCicChangesTableConfig({ hasActions, isEditAllowed, onEdit, onOpenHistory }),
    [hasActions, isEditAllowed, onEdit, onOpenHistory],
  );

  return <TableCDS config={config} data={changes} />;
};

CicChangesTable.propTypes = {
  changes: PropTypes.arrayOf(cicChangePropTypes).isRequired,
  isEditAllowed: PropTypes.bool,
  hasActions: PropTypes.bool,
  onEdit: PropTypes.func,
  onOpenHistory: PropTypes.func,
};

export default memo(CicChangesTable);
